<template>
  <div style="width: 100%">
    <div style="width: 100%">{{ selectedName }}</div>
  </div>
</template>

<script>
export default {
  name: 'SelectDicValue',
  props: {
    typeValue: { type: String, required: false },
    code: { type: String, required: true },
  },
  data() {
    return {
      selectedName: '',
      loading: false,
      options: [],
    }
  },

  methods: {
    async fetchOptions() {
      this.loading = true
      if (window.sessionStorage.getItem(this.code)) {
        this.options = JSON.parse(window.sessionStorage.getItem(this.code))
        return
      }
      try {
        await this.$http
          .get('/Base/Base_Enum/GetByCode?code=' + this.code)
          .then((res) => {
            if (res.Success) {
              let resData = res.Data
              this.options = resData.EnumItems
              window.sessionStorage.setItem(
                this.code,
                JSON.stringify(resData.EnumItems)
              )
              this.selectedName = this.options.find((item) => {
                return item.Value == this.typeValue
              }).Name
            }
          })
      } catch (error) {
        console.error('Failed to fetch options:', error)
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    // this.fetchOptions()
  },
  watch: {
    typeValue: {
      async handler(newVal) {
        console.log(newVal, 'newValnewValnewValnewValnewVal')
        if (!newVal) {
          this.selectedName = ''
          return
        }
        if (!this.options.length) {
          await this.fetchOptions()
        }
        this.selectedName = this.options.find((item) => {
          return item.Value == newVal
        })?.Name
        console.log(this.selectedName, 'this.selectedName')
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped></style>
